import React from 'react';
import Select from 'react-select';
import { sortBy } from 'lodash';
import Label from './Label';
import withOptionItems from './withOptionItems';
import { customStyles, customComponents } from '../customSelectOptions';

class MultiSelectWidget extends React.Component {
  constructor(props) {
    super(props);
    const { optionItems, formData } = props;
    const valueItems = (formData || []).map(item =>
      optionItems.find(opt => opt.value === item),
    );
    this.state = {
      anchor: valueItems[Math.max(0, valueItems.length - 1)],
      search: '',
    };
  }

  componentWillReceiveProps(props) {
    const { optionItems, formData } = this.props;
    const valueItems = (formData || []).map(item =>
      optionItems.find(opt => opt.value === item),
    );
    const newValueItems = (props.formData || []).map(item =>
      props.optionItems.find(opt => opt.value === item),
    );
    if (valueItems.length !== newValueItems.length) {
      this.setState({
        anchor: newValueItems[Math.max(0, newValueItems.length - 1)],
      });
    }
  }

  render() {
    const {
      optionItems,
      name,
      schema,
      uiSchema,
      idSchema,
      required,
      onChange,
      formData,
      disabled,
      readonly,
    } = this.props;
    const id = idSchema.$id;
    const lbl = uiSchema['ui:title'] || schema.title || name;
    const hideTitle = uiSchema['ui:hideTitle'] || schema.hideTitle;
    const description = uiSchema['ui:description'] || schema.description;
    let valueItems = (formData || [])
      .map(item => optionItems.find(opt => opt.value === item))
      .filter(el => el && el);
    const count = uiSchema['ui:count'] || schema.count;
    const sortable = uiSchema['ui:options'] && uiSchema['ui:options'].sortable;

    if (
      uiSchema['ui:options'] &&
      uiSchema['ui:options'].sortField &&
      uiSchema['ui:options'].sortField.length === 2
    ) {
      const [field, order] = uiSchema['ui:options'].sortField;
      valueItems = valueItems.sort((a, b) => {
        if (order === 1) {
          return a[field] > b[field] ? 1 : -1;
        }
        return a[field] < b[field] ? 1 : -1;
      });
    }

    this.resortItems = (values) => {
      const valItem = values.map(v => formData.find(f => f === v));
      onChange(valItem);
    };

    this.reorder = (value, direction) => {
      let values = valueItems.map(v => v.value);
      const indx = values.indexOf(value);
      if (direction === '<') {
        values = [
          ...values.slice(0, indx - 1),
          value,
          values[indx - 1],
          ...values.slice(indx + 1),
        ];
      } else {
        values = [
          ...values.slice(0, indx),
          values[indx + 1],
          value,
          ...values.slice(indx + 2),
        ];
      }
      this.resortItems(values);
    };

    return (
      <div>
        {lbl && !hideTitle && <Label label={lbl} required={required} id={id} />}
        {count && formData && (
          <Label
            className="section-description"
            label={`${formData.length} Selected`}
            id={id}
          />
        )}
        {description && <div className="item-subtitle">{description}</div>}
        <div>
          <Select
            isDisabled={disabled || readonly}
            isMulti
            closeMenuOnSelect={false}
            options={sortBy(optionItems, ({ label }) => label.toUpperCase())}
            value={valueItems.map((v, i) => ({ ...v, index: i }))}
            onChange={(v) => {
              onChange(v.map(val => val.value));
            }}
            styles={customStyles}
            components={customComponents}
            sortable={sortable} // Extended props
            onLeft={value => this.reorder(value, '<')} // Extended props
            onRight={value => this.reorder(value, '>')} // Extended props
          />
          {[...valueItems, ...optionItems].some(item =>
            item.label.includes('**'),
          ) ? (
              <span>
              <br />
              <div className="item-subtitle">** Created by Platform Admin</div>
            </span>
            ) : null}
        </div>
      </div>
    );
  }
}

const HasManyField = withOptionItems(MultiSelectWidget, 'field');

export default HasManyField;



// WEBPACK FOOTER //
// ./src/byob-cms/src/AppLib/formLib/HasManyField.js